import QuizData from './quizz.json';
import { Answer, CurrAnswer, Option, Question, Quiz } from './quizzType';


const MAX_NUM_OF_QUESTIONS: number = QuizData.maxNumOfQuestionsPerRound;

const getRandomInt = (max: number) => {
  return Math.floor(Math.random() * max);
}

const setOptionsRandomOrder = (options: Option[]): Option[] => {
  let optionsInRandomizeOrder: Option[] = [];
  const numOfOptions = options.length;

  for (let ithO = 0; ithO < numOfOptions; ithO++) {
    let index = getRandomInt(options.length);
    optionsInRandomizeOrder.push(options[index]);
    options.splice(index, 1);
  }

  return optionsInRandomizeOrder;
}

const setUpQuestions = (maxNumOfQuestions: number): Question[] => {

  let chosenQuestions: Question[] = [];
  let allQuestions: Question[] = QuizData.questions.map<Question>(q => {  
    return new Question(
      q.question,
      setOptionsRandomOrder(q.options.map<Option>(o => new Option(o.answer, o.isTrue ? o.isTrue : false)))
    )
  }) as any;

  // get random MAX_NUM_OF_QUESTIONS questions from all
  for (let ithQ = 0; ithQ < maxNumOfQuestions; ithQ++) {
    let index = getRandomInt(allQuestions.length);
    chosenQuestions.push(allQuestions[index]);
    allQuestions.splice(index, 1);
  }

  return chosenQuestions;
}


export const NO_ANSWER: number = -1;

export const initQuiz = (): Quiz => {
  return {
    questions: setUpQuestions(MAX_NUM_OF_QUESTIONS) as Question[],
    answers: [] as Answer[],
    currentQuestionIndex: 0 as number,
    score: 0 as number,
    isCompleted: false as boolean
  } as Quiz;
}

export const initCurrAnswer = (): CurrAnswer => {
  return {
    ctx: {} as React.ChangeEvent<HTMLInputElement>,
    optionIndex: NO_ANSWER
  } as CurrAnswer
}

export const colorByCorrectness = (option: Option, answer: Answer, index: number): string => {
  if (option.isTrue && answer.optionIndex === index) return 'correct-answer';
  if (!option.isTrue && answer.optionIndex === index) return 'incorrect-answer';
  if (option.isTrue && answer.optionIndex !== index) return 'answer';
  return '';
}
